// SsoError - displays SSO error with reason from URL params.
import { useSearchParams } from "react-router-dom";

const SsoError = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason") || "An unknown error occurred during sign-in.";

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      fontFamily: "'Inter', sans-serif",
    }}>
      <div style={{ textAlign: "center", maxWidth: 480, padding: 24 }}>
        <h2 style={{ color: "#dc2626", marginBottom: 16 }}>Sign-in Failed</h2>
        <p style={{ color: "#6b7280", marginBottom: 24 }}>{reason}</p>
        <a
          href="/"
          style={{
            display: "inline-block",
            padding: "12px 24px",
            borderRadius: 8,
            background: "#2563eb",
            color: "#ffffff",
            textDecoration: "none",
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          Back to login
        </a>
      </div>
    </div>
  );
};

export default SsoError;
